var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{on:{"click":_vm.clickHandle}},[_vm._t("default"),_c('input',{ref:"inputRef",attrs:{"type":"file","hidden":"","accept":_vm.accept,"multiple":_vm.multiple},on:{"change":_vm.changeFile}}),(_vm.showFile)?_c('div',[(_vm.file)?_c('div',[_vm._v(_vm._s(_vm.file.name))]):_vm._e()]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }